import { Button } from "../buttons/Button/Button";
import "./search.css";

export const SearchItem = ({ image, title, group }) => {
  return (
    <div className="search-item">
      <img src={image} alt={title} />
      <div>
        <div className="search-item-text">
          <p className="body1">{title}</p>
          <p className="body3">{group}</p>
        </div>
        <Button type="learn-more-arrow" />
      </div>
    </div>
  );
};
